
export const SYSTEM_VERSION = {
  version: '3.0.0.006'
};
